import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type RecordingStatusBadgeProps = {
  isRecording: boolean;
};

export function RecordingStatusBadge({ isRecording }: RecordingStatusBadgeProps) {
  const { t } = useTranslation();

  if (!isRecording) return null;

  return (
    <div
      className={cn(
        'absolute top-3 left-3 z-30',
        'flex items-center gap-2',
        'rounded-full bg-black/55 px-3 py-1',
        'text-white text-sm font-bold uppercase tracking-wide',
        'pointer-events-none',
      )}
    >
      <span className="block h-2.5 w-2.5 rounded-full bg-red-500 animate-pulse" />
      {t('record_status.rec')}
    </div>
  );
}

export default RecordingStatusBadge;
